import { actions } from './actions';
import { getters } from './getters';
import { mutations } from './mutations';
import { defaultEoi } from '@/utilities/constants';

export const eoi = {
  namespaced: true,
  state: Object.assign({}, defaultEoi),
  actions,
  getters,
  mutations
};
